(function ($) {
  $(window).on('load', function () {
    new Zoomist('#zoomist', {
      slider: {
        el: '#zoomist-zoomer .custom-slider',
        direction: 'horizontal', // 'horizontal' or 'vertical'
        maxRatio: 5,
      },
      zoomer: {
        inEl: '#zoomist-zoomer .custom-in-zoomer',
        outEl: '#zoomist-zoomer .custom-out-zoomer',
        disableOnBounds: true
      },
    });
    new Zoomist('#zoomist2', {
      slider: {
        el: '#zoomist2-zoomer .custom-slider',
        direction: 'horizontal', // 'horizontal' or 'vertical'
        maxRatio: 5,
      },
      zoomer: {
        inEl: '#zoomist2-zoomer .custom-in-zoomer',
        outEl: '#zoomist2-zoomer .custom-out-zoomer',
        disableOnBounds: true
      },
    });
    $('.project-banner-slider').slick({
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      arrows: false,
      dots: true,
    });
    $('.project-slider').slick({
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
    });
    $('.project-slider2').slick({
      // slidesToShow: 1,
      // slidesToScroll: 1,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      // asNavFor: '.project-slider2-nav',
    });
    $('.project-slider2-nav').on('click', '.js-slideto', function(e) {
      var ind = $(this).data('index');
      $('.project-slider2').slick('slickGoTo', ind);
      return false;
    })
    // $('.project-slider2-nav').slick({
    //   asNavFor: '.project-slider2',
    //   dots: false,
    //   arrows: false,
    //   focusOnSelect: true,
    //   variableWidth: true,
    // });
    $('.gallery.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
    });
    initPhotoSwipeFromDOM('.gallery');

    var resizeId;
    function doneResizing() {
      $('.gallery.grid-h').GridHorizontal({
        item: '.item',
        minWidth: 80,
        maxRowHeight: 120,
        gutter: 10,
      });
    }
    doneResizing();
    $(window).resize(function () {
      clearTimeout(resizeId);
      resizeId = setTimeout(doneResizing, 500);
    });
  });
})($);